export default function HomeFooter({ homePath = "" }: { homePath?: string }) {
  return <>
<footer className="footer">
<div className="wrap">
<div className="footer__top">
<div className="footer__brand">
<img src="/homepage/img/logo.png" alt="CityMoshi" width="150" height="38" />
<p>{"East Africa's social calendar. Find events, book tickets, go together."}</p>
</div>
<div className="footer__col">
<h4>{"Explore"}</h4>
<a href={`${homePath}#today`} data-scroll>{"Today"}</a>
<a href={`${homePath}#discover`} data-scroll>{"Discover"}</a>
<a href={`${homePath}#social`} data-scroll>{"The app"}</a>
</div>
<div className="footer__col">
<h4>{"Organizers"}</h4>
<a href="https://dashboard.citymoshi.com" target="_blank" rel="noreferrer">{"Dashboard"}</a>
<a href={`${homePath}#organizers`} data-scroll>{"Features"}</a>
</div>
<div className="footer__col">
<h4>{"Get the app"}</h4>
<a href="https://apps.apple.com/us/app/citymoshi/id6560116116" target="_blank" rel="noreferrer">{"App Store"}</a>
<a href="https://play.google.com/store/apps/details?id=com.citymoshi.app" target="_blank" rel="noreferrer">{"Google Play"}</a>
</div>
</div>
<div className="footer__word" aria-hidden="true">{"CityMoshi"}</div>
<div className="footer__bottom">
<span>{"\u00a9 "}<span id="year">{"2026"}</span>{" CityMoshi. Made in Kigali."}</span>
<nav aria-label="Legal">
<a href="/privacy-policy" target="_blank" rel="noreferrer">{"Privacy"}</a>
<a href="/terms-of-service" target="_blank" rel="noreferrer">{"Terms"}</a>
</nav>
</div>
</div>
</footer>
  </>;
}
